/**
 * AzimuthPresetButtons - Quick azimuth direction preset buttons
 *
 * Provides N/E/S/W buttons for quickly setting segment azimuth.
 */

import React from 'react';

interface AzimuthPresetButtonsProps {
  currentAzimuth: number;
  onSelectAzimuth: (azimuth: number) => void;
}

const PRESETS = [
  { azimuth: 0, label: 'N' },
  { azimuth: 90, label: 'E' },
  { azimuth: 180, label: 'S' },
  { azimuth: 270, label: 'W' },
];

export function AzimuthPresetButtons({
  currentAzimuth,
  onSelectAzimuth,
}: AzimuthPresetButtonsProps) {
  return (
    <div className="flex gap-1">
      {PRESETS.map(({ azimuth, label }) => (
        <button
          key={azimuth}
          onClick={() => onSelectAzimuth(azimuth)}
          className={`flex-1 py-1 text-xs rounded ${
            currentAzimuth === azimuth
              ? 'bg-green-600 text-white'
              : 'bg-gray-200 hover:bg-gray-300 text-gray-700'
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default AzimuthPresetButtons;
